/**
 * 生活服务
 * 由原 src/router.js 原样搬移（顺序即路由匹配优先级，请勿调整）；
 * 仅把动态导入路径 './views/xxx.vue' 改为 '@/views/xxx.vue'（@ = src）。
 */
export default [
  {
    path: '/live_service',
    name: 'liveService',
    component: () => import('@/views/lifeService/entry.vue'),
    children: [
      {
        path: '',
        name: 'liveServiceHome',
        component: () =>
          import(
            /* webpackChunkName: "Index" */
            '@/views/lifeService/index.vue'
          ),
        meta: {
          title: '生活服务',
          is_festivalPop: true
        }
      },
      {
        path: '/live_service/brand_details',
        name: 'BSbrandDetails',
        component: () =>
          import(
            /* webpackChunkName: "Index" */
            '@/views/lifeService/brandDetailds.vue'
          ),
        meta: {
          title: '品牌详情'
        }
      },
      {
        // 适用门店（与生日专区共用同一页面：城市 tab + 区域分组）
        path: '/live_service/store_list',
        name: 'liveServiceStoreList',
        component: () =>
          import(
            /* webpackChunkName: "Index" */
            '@/views/birthday/storeList.vue'
          ),
        meta: {
          title: '适用门店'
        }
      },
      {
        // h5 的「品牌分类」页：PC 没有对应页面，用商品列表页承接（h5 的 brandHome 会跳到这里）
        path: '/live_service/brand_classification',
        name: 'LbrandClassification',
        component: () =>
          import(
            /* webpackChunkName: "Index" */
            '@/views/lifeService/list.vue'
          ),
        meta: {
          title: '品牌分类'
        }
      },
      {
        path: '/live_service/list',
        name: 'SbrandList',
        component: () =>
          import(
            /* webpackChunkName: "Index" */
            '@/views/lifeService/list.vue'
          ),
        meta: {
          title: '品牌详情'
        }
      }
    ]
  }
];
